import { QueryConfig, useQuery } from "react-query";
import { getNotifySettings } from "../../../queries/notify";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";

type NotifySettings = Awaited<ReturnType<ReturnType<typeof getNotifySettings>>>;

export function useNotifySettings(config?: QueryConfig<NotifySettings, any>) {
  const networkHeaders = useNetworkHeaders();
  const query = useQuery(["notifySettings"], getNotifySettings(networkHeaders), {
    retry(failureCount, error: { status: number }) {
      if (error.status === 404) return false;
      return failureCount < 3;
    },
    refetchOnWindowFocus: false,
    refetchInterval: false,
    refetchOnMount: false,
    ...config,
  });
  const { data: notifySettings, isLoading } = query;
  const isConfigured = !!notifySettings;

  return { query, notifySettings, isConfigured, isLoading };
}
